import apiUrl from "../../../constants";
import axios from "axios";
import VueElementLoading from "vue-element-loading";
import { BasicSelect } from "vue-search-select";
import CryptoJS from "crypto-js";

export default {
  name: "ExportRestrictTempInscanMapping",
  components: { VueElementLoading, BasicSelect },

  data() {
    return {
      flagOptions: [
        { value: "isactive", text: "Is Temp Inscan Mandatory" },
        { value: "isrestrictManual", text: "Restrict Manual" },
        { value: "isenablecenterscaninnew", text: "Enable Center Scan (New)" },
        { value: "manifestscancheck", text: "Manifest Scan Check" },
        {
          value: "isrestrictreprintdirectbagsticker",
          text: "Restrict Reprint Direct Bag Sticker",
        },
        { value: "outscanmanualrestrict", text: "Outscan Manual Restrict" },
        { value: "inscanmanualrestrict", text: "Inscan Manual Restrict" },
        { value: "restrictpaperbagcheck", text: "Restrict Paperbag Check" },
        { value: "istcplinscanallowed", text: "Allow TCPL Inscan" },
        { value: "isrestrictairinscan", text: "Restrict Air Inscan" },
        {
          value: "stickerprintingcontrolsrestrictions",
          text: "Sticker Printing Controls Restrictions",
        },
        {
          value: "islinearflowenabledshipment",
          text: "Linear Flow Enabled Shipment",
        },
        { value: "islinearflowenabledbag", text: "Linear Flow Enabled Bag" },
        {
          value: "isallowotherdestinationbagOut",
          text: "Allow Other Destination Bag Out",
        },
        {
          value: "isallowredirecttolmprintsticker",
          text: "Allow Redirect To LM Print Sticker",
        },
        { value: "isoverageapprovalflag", text: "Overage Approval Flag" },
        { value: "isshortageapprovalflag", text: "Shortage Approval Flag" },
        {
          value: "merge_sec_sort_and_bagging_scan",
          text: "Merge Sec Sort And Bagging Scan",
        },
        {
          value: "isrestrictvehiclesealmanualinscan",
          text: "Restrict Vehicle Seal Manual Inscan",
        },
        {
          value: "isrestrictvehiclesealmanualoutscan",
          text: "Restrict Vehicle Seal Manual Outscan",
        },
        {
          value: "ismandatecompleteinboundflag",
          text: "Mandate Complete Inbound Flag",
        },
        {
          value: "isholdseal",
          text: "Hold Seal Flag",
        },
        { value: "isb2bloadplanenabled", text: "B2B Load Plan Enabled" },
        { value: "isreconqcenabled", text: "Recon QC Enabled" },
        { value: "isodntcenabled", text: "OD NTC Outbound Enabled" },
        { value: "isodntcinboundenabled", text: "OD NTC Inbound Enabled" },
      ],
      selectedFlag: { value: "", text: "" },
      hubs: [],
      isLoading: false,
      showResults: false,
      flagError: "",
      userid: "",
      showLogsModal: false,
      currentHubName: "",
      currentLogs: [],

      // pagination state
      currentPage: 1,
      pageSize: 100,
    };
  },

  computed: {
    paginatedHubs() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.hubs.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.hubs.length / this.pageSize));
    },
    visiblePages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const maxVisible = 10; // Show max 10 page numbers
      const pages = [];

      if (total <= maxVisible) {
        // Show all pages if total is less than max
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        // Always show first page
        pages.push(1);

        let start = Math.max(2, current - 3);
        let end = Math.min(total - 1, current + 3);

        // Add ellipsis after first page if needed
        if (start > 2) {
          pages.push('...');
        }

        // Add middle pages
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        // Add ellipsis before last page if needed
        if (end < total - 1) {
          pages.push('...');
        }

        // Always show last page
        if (total > 1) {
          pages.push(total);
        }
      }

      return pages;
    },
  },

  mounted() {
    try {
      const userdetailEncrypt = localStorage.getItem("userdetail");
      if (userdetailEncrypt) {
        const bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
        const plaintext = bytes.toString(CryptoJS.enc.Utf8);
        const userdetail = JSON.parse(plaintext);
        this.userid = userdetail && userdetail[0] ? userdetail[0].email : "";
      }
    } catch (e) {
      console.error("Error reading user details", e);
    }
  },

  methods: {
    setSelectedFlag(flag) {
      this.selectedFlag = flag || { value: "", text: "" };
      this.flagError = "";
      this.showResults = false;
      this.hubs = [];
    },

    async fetchHubsByFlag() {
      if (!this.selectedFlag || !this.selectedFlag.value) {
        this.flagError = "Please select a flag name.";
        return;
      }

      this.flagError = "";
      this.isLoading = true;
      this.showResults = false;
      this.hubs = [];

      try {
        const url = `${
          apiUrl.api_url_hubops
        }getHubsByInscanFlag?flagName=${encodeURIComponent(
          this.selectedFlag.value
        )}`;
        const res = await axios({
          method: "GET",
          url,
          data: {},
          headers: { authorization: "authkey xB84JJ89Hd25" },
        });

        if (res && res.data && res.data.ResultCode === 100) {
          this.hubs = Array.isArray(res.data.ResponseData)
            ? res.data.ResponseData
            : [];
        } else {
          this.hubs = [];
          this.$alertify.error(
            (res && res.data && res.data.ReturnMessage) ||
              "No hubs found for this flag"
          );
        }
      } catch (err) {
        console.error("Error fetching hubs by flag:", err);
        this.$alertify.error("Error fetching hubs");
        this.hubs = [];
      } finally {
        this.isLoading = false;
        this.showResults = true;
        // reset page to 1 whenever new data is loaded
        this.currentPage = 1;
      }
    },

    clearForm() {
      this.selectedFlag = { value: "", text: "" };
      this.hubs = [];
      this.showResults = false;
      this.flagError = "";
    },

    downloadCSV() {
      if (!this.hubs.length) {
        this.$alertify.error("No data to download");
        return;
      }

      const headers = ["Hub ID", "Hub Name", "Flag Value"];
      const rows = this.hubs.map((hub) => [
        hub.hubid || "",
        hub.hubname || "",
        hub.flagvalue != null ? String(hub.flagvalue) : "",
      ]);

      const csvContent = [
        headers.join(","),
        ...rows.map((r) =>
          r.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(",")
        ),
      ].join("\n");

      const now = new Date();
      const timestamp = `${now.getFullYear()}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}_${String(
        now.getHours()
      ).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}-${String(
        now.getSeconds()
      ).padStart(2, "0")}`;

      const safeFlag = (this.selectedFlag.value || "flag")
        .replace(/\s+/g, "_")
        .replace(/[^\w\-]/g, "");
      const filename = `HubsBy_${safeFlag}_${timestamp}.csv`;

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    async fetchLogs(hubid, hubname) {
      this.isLoading = true;
      this.currentHubName = hubname || "";
      this.currentLogs = [];
      this.showLogsModal = true;

      try {
        const url = `${
          apiUrl.api_url_hubops
        }fetchHubTempInscanRestrictLog?hubid=${encodeURIComponent(
          hubid
        )}&type=1`;
        const res = await axios({
          method: "GET",
          url,
          data: {},
          headers: { authorization: "authkey xB84JJ89Hd25" },
        });

        if (res && res.data && res.data.ResultCode === 100) {
          const data = Array.isArray(res.data.ResponseData)
            ? res.data.ResponseData
            : [];
          this.currentLogs = data.map((log) => ({
            createdby: log.createdby || "",
            date: log.date || "",
            status: log.status || "",
          }));
        } else {
          this.currentLogs = [];
          this.$alertify.error(
            (res && res.data && res.data.ReturnMessage) || "No logs found"
          );
        }
      } catch (err) {
        console.error("Error fetching logs:", err);
        this.$alertify.error("Error fetching logs");
        this.currentLogs = [];
      } finally {
        this.isLoading = false;
      }
    },

    downloadLogsCSV() {
      if (!this.currentLogs.length) {
        this.$alertify.error("No logs to download");
        return;
      }

      const headers = ["Created By", "Created Date", "Status"];
      const rows = this.currentLogs.map((log) => [
        log.createdby || "",
        log.date || "",
        log.status || "",
      ]);

      const csvContent = [
        headers.join(","),
        ...rows.map((r) =>
          r.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(",")
        ),
      ].join("\n");

      const now = new Date();
      const timestamp = `${now.getFullYear()}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}_${String(
        now.getHours()
      ).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}-${String(
        now.getSeconds()
      ).padStart(2, "0")}`;

      const safeHubName = (this.currentHubName || "hub")
        .replace(/\s+/g, "_")
        .replace(/[^\w\-]/g, "");
      const filename = `Logs_for_${safeHubName}_${timestamp}.csv`;

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    changePage(page) {
      const p = Number(page) || 1;
      if (p < 1) return;
      if (p > this.totalPages) return;
      this.currentPage = p;
    },

    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },

    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/ExportRestrictTempInscanMapping/ExportRestrictTempInscanMapping.js